import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WidgetNavigationMap.html?raw';
import on from 'dojo/on';
import _TabEnabledMixin from '../Tabbing/_TabEnabledMixin';
import NavigationArea from '../Navigation/NavigationArea';
import GenericDialog from '../GenericDialog/GenericDialog';
import { ColorHelpers, FeatureHelpers, TranslationHelpers, UrlHelpers } from "../../../more/Helpers";
import TabContainer from '../Tabbing/TabContainer';
import { ExpandableSectionMarkings } from "../Container/ExpandableSectionTypes";
import ExpandableSection from '../Container/ExpandableSection';
import Edit from '../Edit/Edit';
import "../Edit/Edit";
import dojoQuery from 'dojo/query';
import _uiFrameMixin from '../Container/uiFrame';

interface layoutConfig {
    navigationAreaLayout?: "default" | "tiles",
    navigationAreaWidthBaseValue?: "default" | string,
    tileWidth?: string,
    tilesLayout?: Navigation.TilesLayout,
    tileMode?: Navigation.TilesWidthBehaviour,
    alignment?: Navigation.TilesAlignment
    selectable?: boolean
}

/**
 * Generische Home-Navigation als Mixin.
 * Das erstellte Widget ruft die Setup-Funktion auf und konfiguriert dadurch die Navigationsbereiche.
 * WidgetNavigationMap kann mit einem beliebigen <T> typisiert werden um die Daten in den Navigations-Einträgen zu erweitern (für Callbacks etc)
 */
class WidgetNavigationMap<T> extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    //private navigationContainer_Proposition: HTMLElement;
    //private navigationContainer_Attendance: HTMLElement;
    //private navigationArea_Attendance: NavigationArea;
    //private navigationArea_Proposition: NavigationArea;
    private navigationAreasContainer: HTMLElement;

    protected layout: Navigation.TilesLayout = "tiles";
    
    protected layoutConfig: Record<Navigation.TilesLayout, layoutConfig> = {
        "tiles": {
            navigationAreaLayout: "default",
            navigationAreaWidthBaseValue: "default",
            tilesLayout: "tiles",
            alignment: "left",
            tileMode: "strict",
            tileWidth: "35ch",
            selectable: true
        },
        "compact": {
            navigationAreaLayout: "tiles",
            navigationAreaWidthBaseValue: "31%",
            tilesLayout: "compact",
            alignment: "left",
            tileMode: "strict",
            tileWidth: "22ch",
            selectable: true
        },
        "rows": {
            navigationAreaLayout: "default",
            navigationAreaWidthBaseValue: "clamp(40%, 650px, 100%)",
            tilesLayout: "rows",
            alignment: "center",
            tileMode: "strict",
            tileWidth: "100%",
            selectable: true
        }
    };
    private _selectedLayoutConfig: layoutConfig = (this as any).layoutConfig[(this as any).layout];

    private navAreas: Record<string, any> = {};

    protected createNavigationMenu: boolean = false;
    protected createAreaExpanders: boolean = false;

    protected enableLayoutSwitch: boolean = true;

    private openPageNames: Array<string>;

    private groupSettings: Record<string, WidgetNavigation.navigationAreaSettings> = null;

    private tileMapping: Record<string, WidgetNavigation.mappingConfig & T> = null;


    private inputQuicksearch: MdsLax<InstanceType<typeof Edit>>;
    private quickSearchVisible: boolean;
    protected displaySearchThreshold: number = 10; // ab dieser Anzahl von Tiles wird die Suche eingblendet; -1 deaktiviert die Funktion


    private _checkSectionVisiblity(containerNode: HTMLElement | MdsLax<InstanceType<typeof ExpandableSection>>, area: MdsLax<InstanceType<typeof NavigationArea>>, groupname: string, tiles: Array<any>) {
        if (this.createNavigationMenu ) this.createDefaultMenuGroup("navigate");


        if (containerNode && tiles) {

            let exp = containerNode as MdsLax<InstanceType<typeof ExpandableSection>>;
            if (exp.setMarking) {
                containerNode = exp.domNode;
                exp.setMarking(tiles.length == 0 ? ExpandableSectionMarkings.hidden : ExpandableSectionMarkings.default, tiles.length);
            }
            else {
                this.hideNode(containerNode, tiles.length <= 0);
            }
            if (this.createNavigationMenu) {
                this.requestContextButton({
                    label: area.getHeading(),
                    iconClass: area.getHeadingIcon(),
                    permanent: false,
                    enabled: true,
                    name: area.id,
                    placement: "actionbar",
                    callback: lang.hitch(containerNode, "scrollIntoView", { behaviour: "smooth", inline: "center" }),
                    groupName: "navigate"
                });
            }
        }
    }

    private _createNavigationArea() {

        
        let keys = Object.keys(this.tileMapping);
        this.navAreas = {};


        
        for (let entry of keys) {
            let rec = this.tileMapping[entry];
            if (!this.navAreas[rec.navigationAreaName]) {

                let container: HTMLElement = null;

                let expander: MdsLax<InstanceType<typeof ExpandableSection>> = null;
                let area = new NavigationArea();
                area.setAlignment(this._selectedLayoutConfig.alignment);
                area.setLayout(this._selectedLayoutConfig.tilesLayout);
                area.setWidthBaseValue(this._selectedLayoutConfig.tileWidth);

                if (this.createAreaExpanders) {
                    expander = new ExpandableSection();
                    expander.setup(area.domNode, rec.navigationAreaName, "medium", true, true, false, ExpandableSectionMarkings.hidden);
                    expander.placeAt(this.navigationAreasContainer);
                    on(area, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, expander, area, rec.navigationAreaName));

                } else {

                    container = this.UiModder.domConstruct.create("div", {
                        className: "border round padding w3-hide navigationAreaContainer",

                    }, this.navigationAreasContainer);
                    area.placeAt(container);

                    area.setHeading(rec.navigationAreaName);
                    on(area, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, container, area, rec.navigationAreaName));

                }


                this.navAreas[rec.navigationAreaName] = area;

                if (this.groupSettings) {
                    let setting = this.groupSettings[rec.navigationAreaName];
                    if (setting) {
                        area.setHeadingIcon(setting.icon);
                        if (setting.label) area.setHeading(setting.label);
                        if (typeof (setting.order) == "number") {
                            this.UiModder.domStyle.set(container, "order", setting.order);
                        }
                    }
                }
            }
        }
       
    }


    setupTiles(): void {
        let keys = Object.keys(this.tileMapping);
        
        for (let entry of keys) {
            let rec = this.tileMapping[entry];
            let bFeature = true;
            if (rec.featurepath) {
                bFeature = FeatureHelpers.hasFeature(rec.featurepath);//, null, rec.featureVersionMin, rec.featureVersionMax)
            }

            if (bFeature) {
                if (rec.roles) {
                    this.hasUserRole(rec.roles, lang.hitch(this, this._displayTile, entry));
                } else {
                    this._displayTile(entry, true);
                }
                
            }
        }

    }

    private ___onSelect_Navigation(targetname: string, heading: string, color: string, openInBackground?: boolean) {

        let rec = this.tileMapping[targetname];
        let widget = null;
        if (rec.targetWidget) {
            if (rec.dojoProps) {
                let props = {};
                for (let prop of rec.dojoProps) {
                    props[prop.name] = prop.value;
                }
                widget = new rec.targetWidget(props);

            } else {
                widget = new rec.targetWidget();
            }
            
        } else if (rec.targetURL) {
            let url = location.origin + rec.targetURL;
            window.open(url, "_blank");
            return;
        } else if (rec.callback) {
            rec.callback(rec);
            return;
        }

        if (this.isEmbeddedInTab) {
            let tabContainer: MdsLax<InstanceType<typeof TabContainer>> = this.getTabContainer();
            let existingPages = tabContainer.getTabPages().filter(page => page.name == targetname);
            if (existingPages.length) {
                if (openInBackground !== true) {
                    this.requestTabswitch(existingPages[0].name);
                }
            } else {
                if (rec.openInDlg) {
                    this._openAsDlg(rec, widget, heading, tabContainer);
                } else {
                    // widget.show hat weniger Kontroller, bezüglich "Open in background"... das müsste dem UiFrame erst beigebracht werden. dann lieber inzwischen noch manuell requesten.
                    //if (widget instanceof _uiFrameMixin) {
                    //    widget.show("tab", heading, tabContainer?.name);
                    //} else {
                        this.requestNewTabbedContent({
                            enableClosing: rec.openByDefault !== true,
                            label: TranslationHelpers.tryTranslate(heading),
                            name: targetname,
                            widget: widget,
                            coloration: color,
                            groupLabel: TranslationHelpers.tryTranslate(heading),
                            sidebarEntryName: targetname,
                            iconclass: rec.icon,
                        }, openInBackground !== true);
                //    }
                }
            }
        } else {
            // in Popup maybe
            //alert("todo: anzeige wenn nicht in Tab eingebettet noch offen!")

            this._openAsDlg(rec, widget, heading, null);
            return;
        }

        widget.startup();
    }

    private _openAsDlg(rec: WidgetNavigation.mappingConfig & T, widget, heading, tabContainer: MdsLax<InstanceType<typeof TabContainer>>) {
        if (widget instanceof _uiFrameMixin || typeof widget["_uiFrameIsStandalone"] == "boolean") {
            let uiframe = widget as MdsLax<InstanceType<ReturnType<typeof _uiFrameMixin>>>;
            let target = "dlg";
            switch (rec.openInDlg) {
                case "fullsize":
                    target = "fullScreenDlg";
                    break;
                case "bigger":
                    target = "largerDlg";
                    break;
                case "smaller":
                    target = "smallerDlg";
                    break;
            }
            uiframe.show(target as any, heading, tabContainer?.name);            
        } else {
            let dlg = new GenericDialog();
            dlg.setup({
                content: widget,
                header: heading,
                buttonPreset: "close",
                size: rec.openInDlg == "bigger" || rec.openInDlg == "fullsize" || rec.openInDlg == "smaller" ? rec.openInDlg as any : "default"
            });
        }
    }

    private _displayTile(name: string, result: boolean): void {
        if (result) {
            
            this.addTileToArea(name);
        }        
    }
   
    private _tileCount: number = 0;
    private addTileToArea(entryName: string) {

        let rec = this.tileMapping[entryName];

        let navArea = this.navAreas[rec.navigationAreaName] as MdsLax<InstanceType<typeof NavigationArea>>;
        if (!navArea) console.warn(this.id + ": cannot add tile to unknown navigation area??", rec, this.navAreas);
        let label = rec.label;
        let colorclass = rec.colorClass;
        let iconclass = rec.icon;

        let bgColor = null;
        let txtColor = null;

        if (!navArea) return;

        if (rec.color) {
            bgColor = ColorHelpers.getHexColorFromProperty(rec.color, "BG");
            txtColor = ColorHelpers.getHexColorFromProperty(rec.color, "TXT");

            // achtung, je nachdem welches Format da daherkommt, gibt es vielleicht nur EINE Komponente.
            // dann wären die Werte identisch.
            if (bgColor && txtColor == bgColor) {
                txtColor = null;
            }
        }
        navArea.addTile({
            label: label,
            name: entryName,
            target: "",
            callback: lang.hitch(this, this.___onSelect_Navigation, entryName, label, colorclass),
            colorclass: colorclass,
            colorBG: bgColor,
            colorTXT: txtColor,
            //colorBG: color
            //width: this._tileWidth,
            widthMode: this._selectedLayoutConfig.tileMode,
            iconclass: iconclass,
        });

        this._tileCount++;

        

        if (this.displaySearchThreshold > -1 && this._tileCount > this.displaySearchThreshold) {
            this.hideNode(this.searchContainerNode, false);
            this.quickSearchVisible = true;
        }
    }

    private isSetupDone: boolean = false;
    setup(navMap: Record<string, WidgetNavigation.mappingConfig & T>, groupSettings?: Record<string, WidgetNavigation.navigationAreaSettings>, sortyBy: "order" | "label" | "none" = "label") {

        // SORTIERUNG!
        let newMap = {};

        switch (sortyBy) {
            case "none":
                newMap = navMap;
                break;

            case "label":
            default:
                let sortedByLabelArray = Object.keys(navMap).sort((idA, idB) => (TranslationHelpers.tryTranslate(navMap[idA].label) > TranslationHelpers.tryTranslate(navMap[idB].label) ? 1 : -1));
                sortedByLabelArray.forEach(key => newMap[key] = navMap[key]);

                this.tileMapping = newMap;
                break;

            case "order":
                let sortByOrderArray = Object.keys(navMap).sort((idA, idB) => {
                    let entryA = navMap[idA];
                    let entryB = navMap[idB];
                    let sortA = entryA.order;
                    let sortB = entryB.order;
                    if (typeof (sortA) != "number" && typeof (sortB) != "number") {
                        sortA = -9999;
                        sortB = -9998;
                    }
                    else if (typeof (sortA) != "number" && typeof (sortB) == "number") {
                        sortA = sortB - 1;
                    } else if (typeof (sortB) != "number" && typeof (sortA) == "number") {
                        sortB = sortA + 1;
                    }

                    return sortA - sortB;
                });
                sortByOrderArray.forEach(key => newMap[key] = navMap[key]);

                this.tileMapping = newMap;
                break;
        }

       
        if (groupSettings != undefined) {
            this.groupSettings = groupSettings;
        }

        let urlNav = UrlHelpers.getUrlParameterValue("nav");
        let urlPages = UrlHelpers.getUrlParameterValue("pages");

        UrlHelpers.removeUrlParameter("pages");

        this._switchLayout(this.layout);

        this._createNavigationArea();
        this.setupTiles();

        if (urlPages) {
            try {
                let pagenames = urlPages.split(":");
                for (let name of pagenames) {
                    if (this.tileMapping) {
                        let rec = this.tileMapping[name];
                        if (rec) {
                            this.___onSelect_Navigation(name, rec.label, rec.colorClass, name != urlNav);
                        }
                    }
                }
            } catch (ex) {

            }
        }

        if (urlNav && this.isEmbeddedInTab) {
            try {
                if (this.tileMapping) {
                    let rec = this.tileMapping[urlNav];

                    // schon offen?
                    let alreadyOpen = this.openPageNames.filter(name => name == urlNav).length == 1;

                    if (rec) {
                        if (alreadyOpen) {
                            this.requestTabswitch(urlNav);
                        } else {
                            this.___onSelect_Navigation(urlNav, rec.label, rec.colorClass, false);
                        }
                    } else {
                        UrlHelpers.removeUrlParameter("nav");
                    }
                }
            } catch (ex) {
            }
        }
        this.__handleDefaultOpen(!!urlNav);

        this.isSetupDone = true;
    }

    private __handleDefaultOpen(openInBackground?: boolean) {
        for (let entryName in this.tileMapping) {
            let rec = this.tileMapping[entryName];

            // soll default offen sein. falls durch race condition per URL schon geöffnet aufpassen!
            if (rec.openByDefault === true) {
                if (this.isEmbeddedInTab) {
                    let alreadyOpen = this.openPageNames.filter(name => name.toLowerCase() == entryName.toLowerCase()).length == 1;
                    let urlNav = UrlHelpers.getUrlParameterValue("nav");
                    let bIsOpenByNav = false;
                    if (urlNav) bIsOpenByNav = urlNav.toLowerCase() == entryName.toLowerCase();

                    if (!bIsOpenByNav) {
                        if (!alreadyOpen) {
                            this.___onSelect_Navigation(entryName, rec.label, rec.colorClass, openInBackground);
                        } else if (!openInBackground) {
                            this.requestTabswitch(entryName);
                        }
                    }
                }

            }
        }
    }

    private _onSwitchPage(pagename: string) {
        if (!this.isSetupDone) return;

        if (pagename == this.internalName) pagename = null;
        let tabContainer: MdsLax<InstanceType<typeof TabContainer>> = this.getTabContainer();
        let page = tabContainer?.getActivePage();
        let currentPage = page?.name;

        if (currentPage == this.internalName) {
            currentPage = null;
            if (this.quickSearchVisible) this.inputQuicksearch.focus();
        }
        else if (this.tileMapping) currentPage = !!this.tileMapping[currentPage] ? currentPage : null; // nur Namen aus dem Mapping zulassen!

        if (currentPage) {
            UrlHelpers.setUrlParameter("nav", currentPage);
        } else {
            UrlHelpers.removeUrlParameter("nav");
        }

        UrlHelpers.removeUrlParameter("tc");
    }
    private _onClosePage(pagename: string) {
        this._onOpenPage(null);
        this._onSwitchPage(null);
    }
    private _onOpenPage(pagename: string) {
        let tabContainer: MdsLax<InstanceType<typeof TabContainer>> = this.getTabContainer();
        let names = tabContainer.getTabPages().map(page => page.name);


        // nur Namen aus dem Mapping zulassen - nix was danach außerhalb der Navigation noch so passiert!
        if (this.tileMapping) names = names.filter(name => !!this.tileMapping[name]);

        if (names?.length) {
            let ownIndex = names.indexOf(this.internalName);
            if (ownIndex != -1) names.splice(ownIndex, 1);
        }

        this.openPageNames = names;

        if (names.length) {
            UrlHelpers.setUrlParameter("pages", names.join(":"));
        } else {
            UrlHelpers.removeUrlParameter("pages");
        }
    }
    private _onClick_ClearQuicksearch(evt: MouseEvent) {
        this.inputQuicksearch.setValue("");
    }
    private _onChange_Quicksearch() {
        let searchString = this.inputQuicksearch.getValue() as string;

        // komplett resetten:
        this._resetSearchHighlightStyle();

        if (this._searchHighlightTimeout) clearTimeout(this._searchHighlightTimeout);

        if (searchString && searchString != "") {
            this._searchHighlightTimeout = setTimeout(lang.hitch(this, this._setSearchHighlightStyle, searchString), 100);
        }
    }
    private _searchHighlightTimeout: any = null;
    private _searchIsActive: boolean = false;
    private _resetSearchHighlightStyle() {

        if (this._searchIsActive != true) return;

        let currentHighlights = dojoQuery(".searchHighlight", this.navigationAreasContainer);

        this.UiModder.domClass.remove(this.navigationAreasContainer, "searchActive");

        for (let i = 0; i < currentHighlights.length; i++) {
            let node = currentHighlights[i] as HTMLElement;
            this.UiModder.domClass.remove(node, "searchHighlight");
        }

        this._searchIsActive = false;

    } private _setSearchHighlightStyle(searchString: string) {
        if (!searchString) return;

        searchString = searchString.toLowerCase();

        let results = dojoQuery("[data-dojo-attach-point=labelNode]", this.navigationAreasContainer);

        this.UiModder.domClass.add(this.navigationAreasContainer, "searchActive");

        for (let i = 0; i < results.length; i++) {
            let node = results[i] as HTMLElement;
            if (node.innerText.toLowerCase().indexOf(searchString) != -1) {
                this.UiModder.domClass.add(node, "searchHighlight");
            }
        }

        this._searchIsActive = true;
    }

    private _switchLayout(target: Navigation.TilesLayout) {
        
        switch (target) {
            case "tiles":
            case "compact":
            case "rows":
                
                let cfg = this.layoutConfig[target];
                if (cfg && cfg.selectable !== false) {
                    this.layout = target;
                    this._selectedLayoutConfig = cfg;
                }

                break;

            default: return;
        }

        if (this.isEmbeddedInTab) {
            this.requestContextButtonDisable("layoutTiles", target != "tiles" );
            this.requestContextButtonDisable("layoutCompact", target != "compact");
            this.requestContextButtonDisable("layoutRows", target != "rows");
        }

        localStorage.setItem("ego_LayoutSetting_" + this["declaredClass"], target);

        this.UiModder.domClass.toggle(this.navigationAreasContainer, "w3-content vertical nowrap", this._selectedLayoutConfig.navigationAreaLayout == "default");
        this.UiModder.domClass.toggle(this.navigationAreasContainer, "tiles", this._selectedLayoutConfig.navigationAreaLayout == "tiles");
        this.UiModder.domClass.toggle(this.navigationAreasContainer, "customWidth", this._selectedLayoutConfig.navigationAreaLayout == "default" && this._selectedLayoutConfig.navigationAreaWidthBaseValue != "default");

        if (this._selectedLayoutConfig.navigationAreaWidthBaseValue != "default") {
            this.navigationAreasContainer.style.setProperty("--containerBaseWidth", this._selectedLayoutConfig.navigationAreaWidthBaseValue);
        } else {
            this.navigationAreasContainer.style.removeProperty("--containerBaseWidth");
        }

        for (let rec in this.navAreas) {
            let area = this.navAreas[rec] as MdsLax<InstanceType<typeof NavigationArea>>;
            area.setAlignment(this._selectedLayoutConfig.alignment);
            area.setWidthBaseValue(this._selectedLayoutConfig.tileWidth);
            area.setLayout(this._selectedLayoutConfig.tilesLayout);

        }

        if (this._searchIsActive) {
            this._setSearchHighlightStyle(this.inputQuicksearch.getValue())
        }
    }

    _onEmbedding() {
        if (this.isEmbeddedInTab) {
            try {
                let tabContainer: MdsLax<InstanceType<typeof TabContainer>> = this.getTabContainer();
                tabContainer.on("switchPage", lang.hitch(this, this._onSwitchPage));
                tabContainer.on("closePage", lang.hitch(this, this._onClosePage));
                tabContainer.on("openPage", lang.hitch(this, this._onOpenPage));
                
            } catch (ex) {

            }
            let bAvailableTiles = true;
            let bAvailableCompact = true;
            let bAvailableRows = true;
            
            if (this.layoutConfig) {
                let cfgTiles = this.layoutConfig["tiles"];
                if (!cfgTiles || cfgTiles.selectable === false) {
                    bAvailableTiles = false;
                }
                let cfgCompact = this.layoutConfig["compact"];
                if (!cfgCompact || cfgCompact.selectable === false) {
                    bAvailableCompact = false;
                }
                let cfgRows = this.layoutConfig["rows"];
                if (!cfgRows || cfgRows.selectable === false) {
                    bAvailableRows = false;
                }

            }
            if (bAvailableTiles) {
                this.requestContextButton({
                    iconClass: "fas fa-th-large",
                    name: "layoutTiles",
                    callback: lang.hitch(this, this._switchLayout, "tiles"),
                    label: "",
                    placement: "top",
                    permanent: false,
                    styleClass: "tertiaryBG"
                });
            }

            if (bAvailableCompact) {
                this.requestContextButton({
                    iconClass: "fas fa-th",
                    name: "layoutCompact",
                    callback: lang.hitch(this, this._switchLayout, "compact"),
                    label: "",
                    placement: "top",
                    permanent: false,
                    styleClass: "tertiaryBG"
                });
            }

            if (bAvailableRows) {
                this.requestContextButton({
                    iconClass: "fas fa-list fa-flip-horizontal",
                    name: "layoutRows",
                    callback: lang.hitch(this, this._switchLayout, "rows"),
                    label: "",
                    placement: "top",
                    permanent: false,
                    styleClass: "tertiaryBG"
                });
            }
        }
    }

    //BASE
    postMixInProperties() {

        // Standardwert - können aber mit dojo-props übersteuert werden
        if( !this.order) this.order = 1;
        if (!this.title) this.title = TranslationHelpers.tryTranslate("General_Label_Navigation");

        if (!this["targetContainerName"]) this["targetContainerName"] = "main";
        if (!this.internalName) this.internalName = "navigation";
        if (!this.iconclass) this.iconclass = "fas fa-th-large";
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        
        this.RequestManager.handleAs = "json";

        this.openPageNames = [];

        if (this.tileMapping) {
            this._createNavigationArea();
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this.enableLayoutSwitch) {
            let layoutSetting = localStorage.getItem("ego_LayoutSetting_" + this["declaredClass"]);
            if (layoutSetting) {
                this._switchLayout(layoutSetting as any);
            }
        }

        if (this.tileMapping) {
           this.setupTiles();
        }
    }
}

export default mdsWidget(WidgetNavigationMap);